import { FieldType } from '@/catalog/constants/fieldTypes';
import { Field } from '@/catalog/types/field';
import { ALL_CONTEXTS } from '@/common/constants/context';
import { SetupPresetGroupType } from '@/media/entity/SetupPresetGroup';
import MetricScaleContainer from '@/metric/components/MetricScaleContainer/MetricScaleContainer';
import OptMetricBar from '@/metric/components/OptMetricBar/OptMetricBar';
import Diamond from '@/product/entity/Diamond';

export const FIELD_SCINTILLATION: Field = {
  key: 'scintillation.val',
  label: 'Scintillation',
  fullLabel: 'Scintillation',
  type: FieldType.Metric,
  spGroupId: SetupPresetGroupType.FireDiBOX, // todo 6569
  icon: 'metrics-scintillation',
  getValue(p) {
    if (p instanceof Diamond && p.scintillationMetric) {
      return p.scintillationMetric.val;
    }

    return null;
  },
  getText(p) {
    if (p instanceof Diamond && p.scintillationMetric) {
      return p.scintillationMetric.hr;
    }

    return null;
  },
  render(p, { ratio, size, label, icon, metricDataDecorator, isMetricInCard } = {}) {
    if (p instanceof Diamond) {
      return (
        <OptMetricBar
          cutShapeId={p.cutShapeId}
          metric={p.scintillationMetric}
          metricDataDecorator={metricDataDecorator}
          ratio={ratio}
          type="scintillation"
        >
          {(scale, abs) => (
            <MetricScaleContainer
              abs={abs}
              icon={icon}
              inCard={isMetricInCard}
              isMetricCalculated={Boolean(p.scintillationMetric)}
              label={label}
              scale={scale}
              size={size}
            />
          )}
        </OptMetricBar>
      );
    }

    return null;
  },
  iteratee(p) {
    if (p instanceof Diamond && p.scintillationMetric) {
      return p.scintillationMetric.val;
    }

    return null;
  },
  contexts: ALL_CONTEXTS,
};
